<template>
    <div class="flex flex-col">
        <div class="sm:-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="sm:py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border border-gray-200 transition duration-500 ease-in-out dark:border-gray-800 sm:rounded-lg">
                    <table class="mx-auto divide-y divide-gray-300 w-full lg:w-3/4 rounded-md">
                        <thead class="bg-gray-50 transition duration-500 ease-in-out dark:bg-gray-900">
                            <tr>
                                <th v-for="header in headers" scope="col" :style="header.width ? 'width: ' + header.width + 'px' : ''" class="px-6 py-3 text-left mx-auto text-xs font-medium text-gray-500 uppercase tracking-wider transition duration-500 ease-in-out dark:text-white" :class="header.class">
                                    <slot :name="'header.'+header.value" :header="header">
                                        {{ header.text }}
                                    </slot>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-300">
                            <tr v-for="(item, index) in items" class="dark:hover:bg-opacity-80 dark:bg-gray-900  dark:sm:bg-gray-900 bg-white text-xs md:text-base">
                                <td v-for="header in headers" class="mx-auto px-[6px] py-2 lg:px-6 lg:py-4 whitespace-nowrap text-sm font-medium text-gray-900 transition duration-500 ease-in-out dark:text-white" :class="[Array.isArray(header.value) ? '' : '', header.class ? header.class : '']">
                                    <template v-if="Array.isArray(header.value)">
                                        <tw-button v-for="(action, i) in header.value" class="inline-block mr-2" :class="action.class" @click.prevent="action.method(item)" :disabled="isDisabled(action, item)">
                                            <component class="w-5" v-if="action.icon" :is="action.icon"/>
                                            <span v-if="action.showText" class="ml-2 hidden sm:block">{{ action.name }}</span>
                                        </tw-button>
                                    </template>
                                    <slot v-else :name="'item.'+header.value" :item="item">
                                        <span v-if="header.value === 'profile_photo_path'" class="inline-block relative">
                                            <img class="h-10 w-10 rounded-full" :src="item.profile_photo_url" alt="" />
                                            <span v-if="item.active" class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white bg-green-400" />
                                            <span v-else class="absolute top-0 right-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white bg-red-400" />
                                        </span>
                                        <span v-if="header.value === 'amount' || header.value === 'extra_tokens'  || header.value === 'minimum' ">
                                            {{ (item[header.value] / 100) }}
                                        </span>
                                        <span v-else-if="header.value === 'featured' || header.value === 'hidden' || header.value === 'split'">
                                           <span v-if="item[header.value] == 1">
                                               <CheckCircleIcon class="block h-5 w-5 text-green-500" aria-hidden="true" />
                                           </span>
                                           <span v-else>
                                                <XCircleIcon class="block h-5 w-5 text-red-500" aria-hidden="true" />
                                           </span>
                                        </span>
                                        <span v-else>
                                            {{ item[header.value] }}
                                        </span>
                                    </slot>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { XCircleIcon, CheckCircleIcon } from '@heroicons/vue/outline'
export default {
    components: {
        XCircleIcon,
        CheckCircleIcon,
    },
    props: {
        headers: {
            type: Array,
            default: []
        },
        items: {
            type: Array,
            default: []
        },

    },

    setup() {
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })
        const isDisabled = (action, item) => {
            if (action.disabled === undefined && item.banned_at) {
                return true
            }

            return action.disabled
        }

        return {
            isDisabled,
            formatter
        }

    }
}

</script>
